import React, { Component } from 'react'
import Img from 'gatsby-image'
import _ from 'lodash'
import labels from '../../data/labels.json'
import { backendURL } from '../../data/config.json'

//Components
import Modal from './FleetModal'

class FleetItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toogle: false,
    }
    this.renderFeatures = this.renderFeatures.bind(this)
  }
  renderType(type) {
    const currentType = _.find(this.props.types, ['value', type])
    const { label: { en, es } } = currentType
    const { lang } = this.props
    const typeInCurrentLang = lang === 'en' ? en : es
    return typeInCurrentLang
  }
  featureLabels(key, lang) {
    const { featureTypes, item: { features } } = this.props
    const filterFeature = _.find(featureTypes, ['key', key])
    if (key === 'ac') {
      return this.props.item.features.ac === '1' ? (
        <li className={key}>{filterFeature.label[lang]}</li>
      ) : null
    }
    if (key === 'fuel') {
      const filterObjs = _.filter(featureTypes, ['key', key])
      const filterItem = _.find(filterObjs, [
        'value',
        Number(this.props.item.features.fuel),
      ])
      return <li className={key}>{filterItem.label[lang]}</li>
    }

    if (key === 'drive') {
      const filterObjs = _.filter(featureTypes, ['key', key])
      const filterItem = _.find(filterObjs, [
        'value',
        Number(this.props.item.features.drive),
      ])
      return <li className={key}>{filterItem.label[lang]}</li>
    }
    
    return (
      <li className={key}>{`${features[key]} ${filterFeature.label[lang]}`}</li>
    )
  }
  renderFeatures() {
    const { item: { features }, lang } = this.props

    const featureList = _.map(_.keys(features), feature => {
      return this.featureLabels(feature, lang)
    })

    return (
      <div className="features">
        <ul>{featureList}</ul>
      </div>
    )
  }
  render(props) {
    const { title, image, type } = this.props.item
    return (
      <div className="fleet-item">
        <h2>{this.renderType(Number(type))}</h2>
        <div className="top">
          <h4>{title}</h4>
          <a onClick={() => this.setState({ toogle: !this.state.toogle })}>
            {labels.vehicleInfo[this.props.lang]}
          </a>
        </div>
        <div
          className={this.state.toogle ? 'content features-active' : 'content'}
        >
          <div className="image">
            <img
              onClick={() => this.setState({ toogle: !this.state.toogle })}
              src={`${backendURL}${image}`}
              alt={title}
            />
          </div>
          {this.state.toogle && this.renderFeatures()}
        </div>
        <div className="reserve">
          <Modal lang={this.props.lang} />
        </div>
      </div>
    )
  }
}

export default FleetItem



// WEBPACK FOOTER //
// ./src/components/Fleet/FleetItem.js